import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
import { images } from '../data/site';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % buyers.length);
      }, 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-[92px] left-3 right-3 z-50 sm:right-auto" aria-live="polite" data-id="element-43" data-mp="1gx2t254uzpug">
      <AnimatePresence data-id="element-44" data-mp="116w6efuz6vao">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-2xl ring-1 ring-ice-line sm:w-[340px]" data-id="element-45" data-mp="116cy7qv4nl9u">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-ice object-contain" data-id="element-46" data-mp="x51axrzq7c4t" />
            <div className="min-w-0" data-id="element-47" data-mp="s5ojetxwtgvw">
              <p className="text-sm font-bold text-ink" data-id="element-48" data-mp="s4n1c5ih7u4o">
                {buyer.name} <span className="font-medium text-ink-muted" data-id="element-49" data-mp="28jes6dzz4tbv">from {buyer.place}</span>
              </p>
              <p className="text-[13px] text-ink-muted" data-id="element-50" data-mp="23kbn4tjzun3w">
                just purchased <span className="font-semibold text-brand" data-id="element-51" data-mp="2aoth44aubfdx">Dental Predictability Roadmap™</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-success" data-id="element-52" data-mp="2fmv3ay3kbutm">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-53" data-mp="2kmhhb9r7tf3h" />
                Verified purchase · {buyer.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-ink-muted transition-colors duration-150 hover:bg-ice hover:text-ink" aria-label="Close notification" data-id="element-54" data-mp="1ry3iwsw7sgre">
              <XIcon className="h-4 w-4" data-id="element-55" data-mp="26mzn2ev5h9mq" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}